// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"166":"3af87a2f","525":"dccf97ae","862":"85441059"}[chunkId] + ".js";
};